let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("42E4b")).then(() => parcelRequire('fKMkO'));